export default __webpack_public_path__ + "static/logo-white-f3ef95853a427b1b6393f11b66d6af4c.png";